import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services';

export type UseSendServiceRequestReminderPayload = {
  serviceRequestId: string;
};

export const useSendServiceRequestReminder = () => {
  return useMutation({
    mutationKey: ['serviceRequestReminder'],
    mutationFn: ({ serviceRequestId }: UseSendServiceRequestReminderPayload) =>
      api
        .post(`/v3/service_request/${serviceRequestId}/send_reminders`)
        .then((res) => res.data),
  });
};
